import type { PmTimelineMessage } from '@cortex/web-api/clients/admin/api';
import { formatTimestamp } from './format.js';

/**
 * One chat message in the admin conversation viewer. Telegram-faithful bubble:
 * the PM (inbound) sits left on a paper bubble with a bottom-left tail; the
 * agent (outbound) sits right on an ink bubble with a bottom-right tail.
 */
export function MessageBubble({ message }: { message: PmTimelineMessage }) {
  const isInbound = message.direction === 'inbound';
  const failed = message.direction === 'outbound' && message.deliveryStatus === 'failed';
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isInbound ? 'flex-start' : 'flex-end',
      }}
    >
      <div
        style={{
          maxWidth: '78%',
          padding: '10px 14px',
          borderRadius: isInbound ? '18px 18px 18px 4px' : '18px 18px 4px 18px',
          background: isInbound ? 'var(--paper-2)' : 'var(--ink)',
          color: isInbound ? 'var(--ink)' : 'var(--paper)',
          border: isInbound ? '1px solid var(--rule)' : 'none',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--fs-body)',
          lineHeight: 'var(--lh-body)',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {message.body}
      </div>
      <div
        className="mono"
        style={{
          fontSize: 10,
          letterSpacing: 'var(--tracking-mono)',
          color: 'var(--muted)',
          marginTop: 4,
          paddingLeft: isInbound ? 4 : 0,
          paddingRight: isInbound ? 0 : 4,
        }}
      >
        {isInbound
          ? message.actorDisplayName || message.actorTelegramUsername
            ? (message.actorDisplayName ?? `@${message.actorTelegramUsername}`)
            : 'PM'
          : 'agent'}
        {message.pmGroupKind ? ` · ${message.pmGroupKind.replace('_', ' / ')}` : ''} ·{' '}
        {formatTimestamp(message.sentAt)}
        {failed && <span style={{ color: '#c0392b', marginLeft: 6 }}>· failed</span>}
      </div>
    </div>
  );
}
